// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qOdo","icon":"styles_icon__2DJ3j"};